import { flex } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { useDisclosure } from '@onbeam/utils';
import { MobileSubNav } from './MobileSubNav';
import { MenuItem } from '@/components/shared/Menu';
import { forDevelopersMenuItems } from '../DesktopNavigation/GetStartedButton/GetStartedButton.utils';
import { ArrowDiagonalIcon, ChevronRightIcon } from '@onbeam/icons/business';

export const ForDevelopersSubMenu = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Button variant="secondary" size="fullWidth" onClick={onOpen}>
        <div className={flex({ gap: '2', align: 'center' })}>
          For developers <ChevronRightIcon height={16} width={16} />
        </div>
      </Button>
      <MobileSubNav isOpen={isOpen} onClose={onClose}>
        {forDevelopersMenuItems.map((item) => (
          <MenuItem
            href={item.href}
            isExternal={item.isExternal}
            key={item.href}
            className={flex({
              align: 'center',
              gap: '0.5',
              px: '0',
              _hoverFocus: {
                bg: 'mono.primaryFg',
                color: 'mono.tertiary',
              },
            })}
          >
            <span>{item.label}</span>
            {item.isExternal && (
              <ArrowDiagonalIcon
                height={16}
                width={16}
                className={flex({ flexShrink: 0 })}
              />
            )}
          </MenuItem>
        ))}
      </MobileSubNav>
    </>
  );
};
